var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "lds-flask",
    width: "80px",
    height: "80px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lds-flask-cpid-0.e56f9f861a5a5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50,
    width: 100,
    height: 50
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "lds-flask-patid-0.f89b8467a3f7a",
    patternUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "#fac090"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 65.0667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 110;0 -10",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.59s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 135.111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 150;0 -50",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.69s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 33.5333)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 107;0 -7",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 49.1556)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 145;0 -45",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.98s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 130.178)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 138;0 -38",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -15.4822)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 129;0 -29",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.21s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 19.7511)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 132;0 -32",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.52s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 136.429)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 139;0 -39",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.51s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 65.1111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 150;0 -50",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.74s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 71.5956)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 136;0 -36",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.59s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 40.3222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 115;0 -15",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.19s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 50.8444)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 126;0 -26",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.95s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 34.5155)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 154;0 -54",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.19s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 53.9867)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 128;0 -28",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.89s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 146.138)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 147;0 -47",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.48s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 25.1244)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 108;0 -8",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.61s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -0.888885)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 150;0 -50",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.73s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 72.5022)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 133;0 -33",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.56s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -2.13333)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 110;0 -10",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.27s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 99.0667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 146;0 -46",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 70.3778)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 120;0 -20",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.53s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 95.5622)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 151;0 -51",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.29s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 75.8267)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 128;0 -28",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.47s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 29.9378)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 111;0 -11",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.46s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -11.04)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 113;0 -13",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.42s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 -16.2556)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 117;0 -17",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.45s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 6.94222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 106;0 -6",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.12s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 136.429)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 139;0 -39",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.51s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 72.3489)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 139;0 -39",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.59s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 38.5356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 127;0 -27",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.19s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 85.5911)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 141;0 -41",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.38s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -6.66222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 111;0 -11",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.36s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 5.22222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 115;0 -15",
    keyTimes: "0;1",
    dur: "3s",
    begin: "0s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 -5.18222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 147;0 -47",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.82s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -17.9467)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 134;0 -34",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.18s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 81.5778)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 120;0 -20",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.29s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 12.8444)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 126;0 -26",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.7s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 88.3289)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 148;0 -48",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.38s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 50.9778)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 138;0 -38",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.95s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 92.2622)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 124;0 -24",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.11s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 134.498)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 147;0 -47",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.66s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 -22.1156)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 126;0 -26",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.39s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 97.9644)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 126;0 -26",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.02s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 21.2222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 124;0 -24",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.55s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 107.062)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 124;0 -24",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.81s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 13.0556)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 145;0 -45",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.55s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 50.6667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 110;0 -10",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.95s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 104.827)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 146;0 -46",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.11s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 49.3244)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 126;0 -26",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.98s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 -9.03999)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 131;0 -31",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.06s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 19.4667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 110;0 -10",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.73s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -17.8222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 120;0 -20",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.42s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 103.689)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 130;0 -30",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.96s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 108.267)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 110;0 -10",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.51s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 95.4222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 106;0 -6",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 71.4667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 119;0 -19",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 4.94222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 124;0 -24",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.88s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 77.1111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 150;0 -50",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.56s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 115.413)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 116;0 -16",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.48s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 11.3689)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 103;0 -3",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.06s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 34.5155)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 154;0 -54",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.19s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 51.0667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 146;0 -46",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.95s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 76.3111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 114;0 -14",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.35s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 77.3244)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 108;0 -8",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.26s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 110.916)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 127;0 -27",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.78s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -0.537781)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 133;0 -33",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.88s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 79.3333)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 125;0 -25",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.38s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 -10.3778)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 115;0 -15",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.36s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 5.03333)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 107;0 -7",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -11.6911)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 121;0 -21",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.27s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 3.45778)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 138;0 -38",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.76s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 85.1867)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 128;0 -28",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.29s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 -9.69778)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 142;0 -42",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.94s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 52.8622)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 142;0 -42",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.92s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 117.262)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 142;0 -42",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.87s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 117.244)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 135;0 -35",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.78s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 131.007)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 137;0 -37",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.57s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 7.33334)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 125;0 -25",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.82s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 70.04)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 104;0 -4",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.41s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 117.971)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 123;0 -23",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.57s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 21.6889)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 148;0 -48",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 20.6933)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 134;0 -34",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.49s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 -33.5022)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 138;0 -38",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.39s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 16.4311)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 141;0 -41",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.52s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 102.142)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 106;0 -6",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.57s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 36.1511)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 132;0 -32",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.22s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 8.18889)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 103;0 -3",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 135.6)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 140;0 -40",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.54s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 -13.1111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 130;0 -30",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 145.111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 150;0 -50",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.54s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 72.5156)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 118;0 -18",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.47s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 30.1133)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 107;0 -7",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.49s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 104.833)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 125;0 -25",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-0.87s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 0,
    r: 2,
    fill: "#ffffcb",
    transform: "translate(0 58.6667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 128;0 -28",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 10.6133)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 134;0 -34",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.67s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 51.0889)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 148;0 -48",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.95s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 15.6222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 115;0 -15",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.76s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 0,
    r: 3,
    fill: "#ffffcb",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 140;0 -40",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-2.7s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 74.1289)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 139;0 -39",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.56s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 0,
    r: 4,
    fill: "#ffffcb",
    transform: "translate(0 76.2978)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 111;0 -11",
    keyTimes: "0;1",
    dur: "3s",
    begin: "-1.32s",
    repeatCount: "indefinite"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lds-flask-patid-0.f89b8467a3f7a)",
    clipPath: "url(#lds-flask-cpid-0.e56f9f861a5a5)",
    d: "M59,37.3V18.9c3-0.8,5.1-3.6,5.1-6.8C64.1,8.2,61,5,57.1,5H42.9c-3.9,0-7.1,3.2-7.1,7.1c0,3.2,2.2,6,5.1,6.8v18.4c-11.9,3.8-20.6,15-20.6,28.2C20.4,81.8,33.7,95,50,95s29.6-13.2,29.6-29.6C79.6,52.2,70.9,41.1,59,37.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff7c81",
    strokeWidth: 5,
    d: "M59,37.3V18.9c3-0.8,5.1-3.6,5.1-6.8C64.1,8.2,61,5,57.1,5H42.9c-3.9,0-7.1,3.2-7.1,7.1c0,3.2,2.2,6,5.1,6.8v18.4c-11.9,3.8-20.6,15-20.6,28.2C20.4,81.8,33.7,95,50,95s29.6-13.2,29.6-29.6C79.6,52.2,70.9,41.1,59,37.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.02b407966b180f38a094c89ff12a1640.svg";
export { ForwardRef as ReactComponent };